// Folder access is available only in the macOS app.
export default function WorkProjectFolderButton() { return null; }
